import fetch from "isomorphic-fetch";
import { checkHttpStatus, parseJSON } from "../utils";
import {
  DATA_FETCH_BLOG_POSTS_REQUEST,
  DATA_RECEIVE_BLOG_POSTS_DATA
} from "../constants";

export function dataReceiveBlogPostsData(data) {
  return {
    type: DATA_RECEIVE_BLOG_POSTS_DATA,
    payload: {
      data
    }
  };
}

export function dataFetchBlogPostsRequest() {
  return {
    type: DATA_FETCH_BLOG_POSTS_REQUEST
  };
}

export function dataFetchBlogPosts(category, numPosts) {
  numPosts = numPosts || 20;
  category = category || "";

  return (dispatch, state) => {
    dispatch(dataFetchBlogPostsRequest());
    return fetch(
      `//${BLOG_URL}/wp-json/wp/v2/posts?_embed&filter[posts_per_page]=${
        numPosts
      }&filter[category_name]=${category}`
    )
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(dataReceiveBlogPostsData(response));
      })
      .catch(error => {
        console.log(error, "An error occurred");
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  };
}
